import axios from 'axios';
import { AvailabilityResponseDto, BookingConfirmationDto, BookingResponseDto, BookingServiceResponseDto, CreatePublicBookingDto, PublicBookingBrandingDto } from '../types/booking';
import { SERVICES_API_BASE_URL } from './apiConfig';

const API_BASE = `${SERVICES_API_BASE_URL}/api/PublicBooking`;

const api = axios.create();

// Public endpoints are unauthenticated - used by the embeddable booking widget.
export const bookingPublicApi = {
  getServices: (bookingSlug: string) => api.get<BookingServiceResponseDto[]>(`${API_BASE}/services`, { params: { bookingSlug } }),
  getSettings: (bookingSlug: string) => api.get<PublicBookingBrandingDto>(`${API_BASE}/settings`, { params: { bookingSlug } }),
  getAvailability: (
    bookingSlug: string,
    serviceId: string,
    startDate: string,
    endDate: string
    ) =>
    api.get<AvailabilityResponseDto[]>(
        `${API_BASE}/availability`,
        {
        params: {
            bookingSlug,
            serviceId,
            startDate,
            endDate,
        },
    }
  ),
  createBooking: (data: CreatePublicBookingDto) => api.post<BookingResponseDto>(API_BASE, data),
  getConfirmation: (reference: string) => api.get<BookingConfirmationDto>(`${API_BASE}/confirmation/${reference}`),
};

